import type { ScreenDefinition, ScreenProps } from '../../contracts';
import { StockList, StockSelector } from './StockList';
import { StockCard } from './StockCard';
import type { StockRow } from './types';
import './stock.css';
export { StockSelector } from './StockList';
export type { StockSelectorProps } from './StockList';
export type { StockRow } from './types';
function ListScreen(props: ScreenProps) { return <StockList setDirty={props.setDirty} setCloseBlocked={props.setCloseBlocked} />; }
function CardScreen(props: ScreenProps) { return <StockCard code={props.params?.code as string | undefined} copyCode={props.params?.copyCode as string | undefined} setDirty={props.setDirty} setCloseBlocked={props.setCloseBlocked} />; }
function SelectScreen(props: ScreenProps) { return <StockSelector initialSearch={props.params?.search as string | undefined} warehouse={props.params?.warehouse as string | undefined} allowAllPlusOne={props.params?.allowAllPlusOne as boolean | undefined} selectionLimit={props.params?.selectionLimit as number | undefined} onSelect={(row, allPlusOne, visibleRows) => {
  if (typeof props.params?.onSelect === 'function') (props.params.onSelect as (row: StockRow, allPlusOne?: boolean, visibleRows?: StockRow[]) => void)(row, allPlusOne, visibleRows);
}} />; }
export const screens: ScreenDefinition[] = [
  { id: 'stock.list', title: 'Artikelstamm', component: ListScreen },
  { id: 'stock.card', title: 'Artikel', component: CardScreen },
  { id: 'stock.select', title: 'Artikel', component: SelectScreen },
];
